var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bx-pagination", attrs: { id: "shops_vue_pagination" } },
    [
      _c("div", { staticClass: "bx-pagination-container" }, [
        _c(
          "ul",
          [
            _vm.arResult.CURRENT_PAGE > 1
              ? _c("li", { staticClass: "bx-pag-prev" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.prevPage(_vm.n)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            Назад\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.activePages, function (n) {
              return _c(
                "li",
                { class: { "bx-active": n == _vm.arResult.CURRENT_PAGE } },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.changePage(n)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" + _vm._s(n) + "\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.arResult.CURRENT_PAGE < _vm.arResult.PAGE_COUNT
              ? _c("li", { staticClass: "bx-pag-next" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.nextPage(_vm.n)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            Вперед\n\t\t\t\t\t\t"
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }